import { useEffect, useState } from 'react';

export const useBalanceVisibilityState = () => {
  const [isBalanceHidden, setIsBalanceHidden] = useState(
    localStorage.getItem('isBalanceHidden') === 'true'
  );

  useEffect(() => {
    localStorage.setItem('isBalanceHidden', String(isBalanceHidden));
  }, [isBalanceHidden]);

  return {
    isBalanceHidden,
    setIsBalanceHidden,
  };
};
